/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useRef, useContext } from 'react';
import {
  saveUploadInfo,
  saveUploadDetails,
  saveUploadSizes,
  saveDummy,
  removeDummy,
  setAddVideo,
} from 'store/store';
import { v4 as uuid } from 'uuid';
import ForNoImage from 'Assets/Placeholder.png';
import {
  Dialog,
  DialogContent,
  IconButton,
  CircularProgress,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Collapse,
  Tooltip,
  Checkbox,
  FormControlLabel,
  Divider,
} from '@material-ui/core';
import {
  Close,
  CloudUpload,
  VideoLibrary,
  Public,
  Lock,
  Group,
  CheckCircle,
  ExpandMore,
  ExpandLess,
  PlayArrow,
  Edit,
  Description,
  Category,
  PlaylistPlay,
  Visibility,
  Add,
} from '@material-ui/icons';
import CreateCategoryPage from 'Pages/private/content-layout/CreateCategory';
import useSWR from 'swr';
import { endpoints, dataFetcher, axios, baseUrl } from 'Api';
import { AppContext } from 'Context';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import { ALLOWED_UPLOADS_COUNT } from 'Commons';
import { uploadLargeFile } from '../../Utils/uploadWrapper';
import { getBucketName, generateS3Url } from '../../Api/awsConfig';
import styles from './VideoUploadModal.module.css';
import MultipleVideoUploadModal from './MultipleVideoUploadModal';

const VideoUploadModal = ({
  open,
  onClose,
  userDataProp = null,
  initialFile = null,
}) => {
  const {
    userDetails,
    setUploadContainer,
    setUploadContainer2,
    setIamUploading,
    draftCategoryState,
    setDraftCategoryState,
    base64ToBinary,
    setAppSnackbar,
    autoSignIn,
    showMultipleModal,
    setShowMultipleModal,
    selectedFilesMulti,
    setSelectedFilesMulti,
    pendingVideoFile,
    setPendingVideoFile,
    defaultCategoryName,
    freePlanLimitMb,
    subscriptionDetails,
    totalOnGoingUploadSize
  } = useContext(AppContext);

  const fileInputRef = useRef(null);
  const userId = userDetails?.isSubscription?.user_id || localStorage.getItem('id');
  const navigate = useNavigate();

  // Redux for upload tracking
  const dispatch = useDispatch();
  const updateUploadDetails = (draft_id, data) => {
    dispatch(saveUploadDetails({ [draft_id]: data }));
  };
  const uploadPercentages = useSelector((state) => state.upload);
  const updateUploadPercentages = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };

  // Detect active uploads
  const activeUploads = Object.entries(uploadPercentages).filter(
    ([_, progress]) => progress !== null && progress !== undefined && progress !== 'Please wait'
  );
  const hasActiveUploads = activeUploads.length > 0;

  // Multiple files detection

  const [uploadLimitError, setUploadLimitError] = useState(null);
  const [userData, setUserData] = useState(null);
  // Single file states
  const [videoFile, setVideoFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [visibility, setVisibility] = useState('2');
  const [selectedCategory, setSelectedCategory] = useState({
    value: '',
    name: '',
  });
  const [selectedSubCategory, setSelectedSubCategory] = useState('');

  const [selectedPlaylist, setSelectedPlaylist] = useState('');
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);
  const [selectedThumbnail, setSelectedThumbnail] = useState(0);
  const [customThumbnail, setCustomThumbnail] = useState(null);
  const [isCustomThumbnailSelected, setIsCustomThumbnailSelected] = useState(false);
  const customThumbnailInputRef = useRef(null);
  const [showAdditionalFields, setShowAdditionalFields] = useState(true);
  const [isGeneratingThumbnails, setIsGeneratingThumbnails] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isProcessingPendingFile, setIsProcessingPendingFile] = useState(false);
  const [videoDuration, setVideoDuration] = useState(0);
  const [videoSize, setVideoSize] = useState(0);
  const [videoHeight, setVideoHeight] = useState(0);
  const [videoWidth, setVideoWidth] = useState(0);
  const additionalOptionsRef = useRef(null);

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupsLoaded, setGroupsLoaded] = useState(false);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
  const [pendingCategorySelect, setPendingCategorySelect] = useState(false);

  // Fetch categories (kept for potential manual revalidation)
  const { isValidating: gettingCategories, mutate: getCategories } = useSWR(
    [endpoints.getMyCategories],
    {
      fetcher: (url) => dataFetcher(url),
      onSuccess: ({ success, data }) => {
        if (success && data) {
          setCategories(data);
        }
      },
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  // Fetch subcategories
  const { isValidating: gettingSubCategories, mutate: getSubCategories } = useSWR([endpoints.getMySubCategory], {
    fetcher: (url) => dataFetcher(url),
    onSuccess: ({ success, data }) => {
      if (success && data) {
        setSubCategories(data);
      }
    },
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  // Fetch playlists
  const { isValidating: gettingPlaylists, mutate: getPlaylists } = useSWR(
    [endpoints.getMyPlaylist],
    {
      fetcher: (url) => dataFetcher(url),
      onSuccess: ({ success, data }) => {
        if (success && data) {
          setPlaylists(data);
        }
      },
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  // Fetch groups
  const { isValidating: gettingGroups, mutate: getGroups } = useSWR(
    [endpoints.getMyGroups],
    {
      fetcher: (url) => dataFetcher(url),
      onSuccess: ({ success, data, message }) => {
        if (success && data) {
          setGroups(data);
          if (
            data.length > 0
            && visibility === 'Group'
            && selectedGroups.length === 0
          ) {
            setSelectedGroups([data[0].id]);
          }
        } else if (!success && message === 'No Groups found') {
          setGroups([]);
        }
        setGroupsLoaded(true);
      },
      onError: (error) => {
        console.error('Groups API error:', error);
        setGroups([]);
        setGroupsLoaded(true);
      },
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  // Trigger initial data fetching when modal opens
  useEffect(() => {
    const fetchAllData = async () => {
      if (!open) return;

      // Reset loaded states
      setGroupsLoaded(false);

      try {
        // Fetch categories
        const categoriesResponse = await dataFetcher(endpoints.getMyCategories);
        if (categoriesResponse.success && categoriesResponse.data) {
          setCategories(categoriesResponse.data);
          const allVideosOption = categoriesResponse.data?.find((opt) => opt?.title === defaultCategoryName);
          if (categoriesResponse.data.length > 0 && !selectedCategory.value) {
            setSelectedCategory({
              value: allVideosOption?.id || categoriesResponse.data[0].id,
              name: allVideosOption?.title || categoriesResponse.data[0].title,
            });
          }
        }

        // Fetch subcategories
        const subCategoriesResponse = await dataFetcher(endpoints.getMySubCategory);
        if (subCategoriesResponse.success && subCategoriesResponse.data) {
          setSubCategories(subCategoriesResponse.data);
        }

        // Fetch playlists
        const playlistsResponse = await dataFetcher(endpoints.getMyPlaylist);
        if (playlistsResponse.success && playlistsResponse.data) {
          setPlaylists(playlistsResponse.data);
        }

        // Fetch groups
        const groupsResponse = await dataFetcher(endpoints.getMyGroups);
        if (groupsResponse.success && groupsResponse.data) {
          setGroups(groupsResponse.data);
          if (
            groupsResponse.data.length > 0
            && visibility === '3'
            && selectedGroups.length === 0
          ) {
            setSelectedGroups([groupsResponse.data[0].id]);
          }
        } else if (!groupsResponse.success && groupsResponse.message === 'No Groups found') {
          setGroups([]);
        }
        setGroupsLoaded(true);
      } catch (error) {
        console.error('Error fetching data:', error);
        setGroups([]);
        setGroupsLoaded(true);
      }
    };

    fetchAllData();
  }, [open]);

  // Handle category creation callback - refresh list and select new category
  const handleCategoryCreated = async () => {
    setPendingCategorySelect(true);
    try {
      const categoriesResponse = await dataFetcher(endpoints.getMyCategories);
      if (categoriesResponse.success && categoriesResponse.data) {
        setCategories(categoriesResponse.data);
        // Select the most recently created category (last in the list by id)
        const sortedCategories = [...categoriesResponse.data].sort((a, b) => b.id - a.id);
        if (sortedCategories.length > 0) {
          const newestCategory = sortedCategories[0];
          setSelectedCategory({
            value: newestCategory.id,
            name: newestCategory.title,
          });
        }
      }
    } catch (error) {
      console.error('Error refreshing categories:', error);
    } finally {
      setPendingCategorySelect(false);
      setShowCreateCategoryModal(false);
    }
  };

  const generateThumbnailsFromVideo = (file) => {
    if (!file) return;
    setIsGeneratingThumbnails(true);
    const video = document.createElement('video');
    const videoUrl = URL.createObjectURL(file);
    video.src = videoUrl;
    video.crossOrigin = 'anonymous';
    video.muted = true; // avoid autoplay restrictions
    video.playsInline = true;

    // Add error handling for thumbnail generation failure
    video.onerror = () => {
      URL.revokeObjectURL(videoUrl);
      video.remove();
      setThumbnails([ForNoImage]); // Use ForNoImage as fallback
      setSelectedThumbnail(0);
      setIsGeneratingThumbnails(false);
    };

    video.onloadeddata = () => {
      const { duration } = video;
      setVideoDuration(duration);

      // Capture video dimensions
      setVideoHeight(video.videoHeight);
      setVideoWidth(video.videoWidth);

      const thumbnailCount = 6;
      const interval = duration / (thumbnailCount + 1);
      const tempThumbnails = [];

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      let currentIndex = 1;

      const captureNextFrame = () => {
        if (currentIndex > thumbnailCount) {
          // If no thumbnails were generated, use ForNoImage
          if (tempThumbnails.length === 0) {
            setThumbnails([ForNoImage]);
          } else {
            setThumbnails(tempThumbnails);
          }
          setSelectedThumbnail(0);
          setIsGeneratingThumbnails(false);
          URL.revokeObjectURL(videoUrl); // cleanup
          video.remove(); // cleanup video element
          return;
        }
        const time = interval * currentIndex;
        video.currentTime = time;

        video.onseeked = () => {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const url = URL.createObjectURL(blob);
                tempThumbnails.push(url);
              }

              currentIndex += 1;
              captureNextFrame(); // move to next frame after finishing this one
            },
            'image/jpeg',
            0.9
          );
        };
      };

      captureNextFrame();
    };
  };

  const handleCustomThumbnailUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      setAppSnackbar({
        open: true,
        message: 'Please upload a valid image file (JPG, PNG, or WebP)',
        severity: 'error',
      });
      return;
    }

    // Create preview URL
    const reader = new FileReader();
    reader.onload = (e) => {
      setCustomThumbnail(e.target.result);
      setIsCustomThumbnailSelected(true);
      setSelectedThumbnail(null);
    };
    reader.readAsDataURL(file);
  };

  const handleFileSelect = async (event) => {
    setIsProcessingPendingFile(true);
    const files = Array.from(event.target.files);
    const allowedVideoTypes = [
      '.mp4',
      '.mov',
      '.mpg',
      '.m4v',
      '.m2ts',
      '.hevc',
      '.h264',
    ];
    const videoFiles = files.filter((file) => {
      const fileExtension = file.name
        .toLowerCase()
        .slice(file.name.lastIndexOf('.'));
      return allowedVideoTypes.includes(fileExtension);
    });

    if (videoFiles.length === 0) {
      console.error(
        'Invalid file type selected. Supported formats: MP4, MOV, MPG, M4V, M2TS, HEVC, H264'
      );
      setIsProcessingPendingFile(false); // Turn off loader on error
      return;
    }

    // Check upload limit for non-subscribed users
    let limitError = null;
    let currentUserData = null;
    try {
      const res = await autoSignIn();
      currentUserData = res?.data;
      setUserData(currentUserData); // Store for reuse throughout session

      if (res?.data?.subscription == null) {
        // Check upload count limit
        if (res?.data?.totalContentUploaded + videoFiles.length > ALLOWED_UPLOADS_COUNT) {
          limitError = {
            currentCount: res?.data?.totalContentUploaded,
            tryingToUpload: videoFiles.length,
            maxAllowed: ALLOWED_UPLOADS_COUNT,
            message: `Upload limit exceeded. You can upload a maximum of ${ALLOWED_UPLOADS_COUNT} videos. ${res?.data?.totalContentUploaded === 0
                ? `You are trying to upload ${videoFiles.length}.`
                : `You currently have ${res?.data?.totalContentUploaded} videos and trying to upload ${videoFiles.length} more.`
              }`,
          };
        }
        // Check file size limit for free plan users
        if (!limitError && freePlanLimitMb) {
          const totalSizeMB = videoFiles.reduce((sum, file) => sum + (file.size / 1024 / 1024), 0);
          const usedStorage = subscriptionDetails?.storageUsed?.total_storage;
          const allFullStorage = totalSizeMB + usedStorage + totalOnGoingUploadSize;
          const allowedStorage = (usedStorage + totalOnGoingUploadSize) - freePlanLimitMb;
          const formattedStorage = (Math.abs(allowedStorage) / 1024).toFixed(2);
          const exceededBy = allFullStorage - freePlanLimitMb;
          console.log('totalSizeMB:', allFullStorage, totalSizeMB, usedStorage, freePlanLimitMb, totalOnGoingUploadSize);
          if (allFullStorage > freePlanLimitMb) {
            limitError = {
              totalSize: allFullStorage,
              maxAllowed: freePlanLimitMb,
              message: `You can upload files up to ${Math.floor(freePlanLimitMb / 1024)} GB on the free plan. You can add ${formattedStorage} GB more.`, // message: `You can upload files up to ${Math.floor(freePlanLimitMb / 1024)} GB on the free plan. Your selected video${videoFiles.length > 1 ? 's' : ''} total ${totalSizeMB.toFixed(2)} MB — you exceeded the limit by ${exceededBy.toFixed(2)} MB.`,
            };
          }
        }
      }
    } catch (error) {
      console.error('Error checking upload limits:', error);
    }

    if (videoFiles.length > 1) {
      // Multiple files - show multiple upload modal and close this one
      setSelectedFilesMulti(videoFiles);
      setUploadLimitError(limitError);
      setShowMultipleModal(true);
      setIsProcessingPendingFile(false); // Turn off loader when switching to multiple modal
      // Don't close the parent modal here, let the multiple modal handle it
    } else {
      // Single file - set error if exists and continue with existing logic
      setUploadLimitError(limitError);
      const file = videoFiles[0];
      setVideoFile(file);
      setVideoSize(file.size);
      setIsProcessingPendingFile(false); // Turn off loader when file is set
      const url = URL.createObjectURL(file);
      setVideoUrl(url);

      // Set title from filename (remove extension)
      const filename = file.name.replace(/\.[^/.]+$/, '');
      setTitle(filename);

      // Generate thumbnails
      generateThumbnailsFromVideo(file);
    }
  };

  // Process initial file if provided (from props or global state)
  useEffect(() => {
    const fileToProcess = pendingVideoFile || initialFile;
    if (open && fileToProcess && !videoFile) {
      setIsProcessingPendingFile(true);
      // Create a synthetic event to pass to handleFileSelect
      const syntheticEvent = {
        target: {
          files: [fileToProcess],
        },
      };
      handleFileSelect(syntheticEvent);
    }
    return () => {
      setPendingVideoFile(null);
    };
  }, [open, initialFile, pendingVideoFile, videoFile]);

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  // File validation helper
  const validateVideoFiles = (files) => {
    const supportedFormats = [
      '.mp4',
      '.mov',
      '.mpg',
      '.m4v',
      '.m2ts',
      '.hevc',
      '.h264',
    ];
    const invalidFiles = [];
    const validFiles = [];

    Array.from(files).forEach((file) => {
      const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;
      if (supportedFormats.includes(fileExtension)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    return { validFiles, invalidFiles };
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);

    // Validate files
    const { validFiles, invalidFiles } = validateVideoFiles(files);

    if (invalidFiles.length > 0) {
      setAppSnackbar({
        isVisible: true,
        message: `Unsupported file format(s): ${invalidFiles.join(
          ', '
        )}. Please upload videos in MP4, MOV, MPG, M4V, M2TS, HEVC, or H264 format.`,
        type: 'error',
      });
    }

    if (validFiles.length > 0) {
      // Create a fake event object that mimics the file input event
      const fakeEvent = {
        target: {
          files: validFiles,
        },
      };

      handleFileSelect(fakeEvent);
    }
  };

  const updateDummy = (dummy, status = 0) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const handleClose = () => {
    // Clean up URLs
    if (videoUrl) {
      URL.revokeObjectURL(videoUrl);
    }
    thumbnails.forEach((url) => {
      if (url && url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });

    // Reset state
    setVideoFile(null);
    setVideoUrl('');
    setTitle('');
    setDescription('');
    setVisibility('2');
    setSelectedCategory({ value: '', name: '' });
    setSelectedSubCategory('');
    setSelectedPlaylist('');
    setSelectedGroups([]);
    setThumbnails([]);
    setSelectedThumbnail(0);
    setCustomThumbnail(null);
    setIsCustomThumbnailSelected(false);
    setShowAdditionalFields(true);
    setIsGeneratingThumbnails(false);
    setIsPublishing(false);
    setIsProcessingPendingFile(false);
    setVideoDuration(0);
    setVideoSize(0);
    setVideoHeight(0);
    setVideoWidth(0);
    setSelectedFilesMulti([]);
    setShowMultipleModal(false);

    onClose();
  };
  function changeSize(size) {
    const newSize = size / 1024 / 1024;
    return newSize.toFixed(2);
  }

  const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  const convertBlobUrlToBase64 = async (blobUrl) => {
    try {
      const response = await fetch(blobUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch blob');
      }
      const blob = await response.blob();
      const base64 = await blobToBase64(blob);
      return base64;
    } catch (error) {
      console.error('Error converting blob to base64:', error);
      return '';
    }
  };
  const toBase64ForList = async (blobUrl) => {
    try {
      const response = await fetch(blobUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch blob');
      }
      const blob = await response.blob();
      const base64 = await blobToBase64(blob);
      return base64;
    } catch (error) {
      console.error('Error converting blob to base64:', error);
      return '';
    }
  };

  const addVideoToAPI = async (draftID, draftCategoryState) => {
    try {
      const apiUrl = `${baseUrl}/V6/addVideo`;
      const formData = new FormData();
      const draftData = draftCategoryState[draftID];
      if (draftData) {
        formData.append('draft_id', draftID || '');
        formData.append('title', draftData.title || '');
        formData.append('category_id', draftData.category || '');
        formData.append('file_name', draftData.fileName || '');
        if (draftData.thumbnail) {
          const binaryThumbnail = base64ToBinary(draftData.thumbnail);
          formData.append('thumbnail', binaryThumbnail);
        }
        // Append each thumbnail as binary (excluding the main thumbnail)
        if (draftData.thumbnails && Array.isArray(draftData.thumbnails)) {
          draftData.thumbnails.forEach((binaryThumbnail, index) => {
            // Skip the thumbnail that matches the selected main thumbnail index
            if (binaryThumbnail && index !== draftData.selectedThumbnailIndex) {
              formData.append('thumbnails[]', binaryThumbnail);
            }
          });
        }
        formData.append('description', draftData.description || '');
        formData.append('video_size', changeSize(draftData.videoSize) || '');
        formData.append(
          'group_ids', (draftData.selectedGroups || []).join(',')
        );
        formData.append('visibility', draftData.visibility || '');
        formData.append(
          'subcategory_id',
          draftData.selectedSubCategory || ''
        );
        formData.append('playlist_ids', draftData.selectedPlaylist || '');
        formData.append('videoHeight', draftData.videoHeight || '');
        formData.append('videoWidth', draftData.videoWidth || '');
        formData.append('videoOreintation', draftData.orientation || '');
        formData.append('s3_status', draftData.uploadStatus || '');
        formData.append('uploadKey', draftData.uploadKey || '');
        formData.append(
          'bucket_folder_path',
          `${draftData.s3Url}${draftData.uploadBucket}/${draftData.uploadKey}`
        );
        formData.append('s3_image_bucket_url', draftData.s3Url || '');
      }
      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      console.error('Error adding video to API:', error.message || error);
      throw error;
    }
  };

  const handlePublish = async () => {
    if (!videoFile) return;

    // Validate group selection if visibility is Group
    if (
      visibility === '3'
      && (!selectedGroups || selectedGroups.length === 0)
    ) {
      alert(
        'Please select at least one group when Group visibility is selected.'
      );
      return;
    }

    setIsPublishing(true);
    const fileExtension = videoFile.name.split('.').pop().toLowerCase();
    const number = Math.floor(Math.random() * 10000) + 1;
    const fileName = `${Date.now()}-${userId}-video-${number}.${fileExtension}`;
    const bucketName = getBucketName(userId);
    const s3Url = generateS3Url();
    const draftID = uuid();

    // Get main thumbnail (handle both normal thumbnails and ForNoImage case)
    let thumbnailBase64 = '';
    const selectedThumbnailSrc = thumbnails[selectedThumbnail];
    if (isCustomThumbnailSelected && customThumbnail) {
      // Use custom thumbnail if selected
      thumbnailBase64 = customThumbnail;
    } else if (selectedThumbnailSrc === ForNoImage) {
      // User selected ForNoImage option (when thumbnail generation failed)
      // Convert ForNoImage to base64
      const response = await fetch(ForNoImage);
      const blob = await response.blob();
      thumbnailBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } else if (selectedThumbnailSrc && selectedThumbnailSrc.startsWith('blob:')) {
      // Normal blob thumbnail selected
      try {
        thumbnailBase64 = await convertBlobUrlToBase64(selectedThumbnailSrc);
      } catch (error) {
        console.error('Error converting thumbnail:', error);
        // Fallback to ForNoImage
        const response = await fetch(ForNoImage);
        const blob = await response.blob();
        thumbnailBase64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }
    } else {
      // No thumbnails, use ForNoImage
      const response = await fetch(ForNoImage);
      const blob = await response.blob();
      thumbnailBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }
    // Convert all thumbnails to binary in parallel (handle ForNoImage case)
    const thumbnailsBinary = await Promise.all(
      thumbnails.map(async (thumbnail, i) => {
        try {
          // Handle ForNoImage case (when thumbnail generation failed)
          if (thumbnail === ForNoImage) {
            // Convert ForNoImage to base64 then to binary
            const response = await fetch(ForNoImage);
            const blob = await response.blob();
            const base64 = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            });
            return base64ToBinary(base64);
          }

          if (!thumbnail) {
            return null;
          }
          const base64 = await toBase64ForList(thumbnail);
          return base64ToBinary(base64);
        } catch (error) {
          console.error(`Error converting thumbnail ${i}:`, error.message);
          return null;
        }
      })
    );
    // Use the imported uploadLargeFile utility
    uploadLargeFile({
      bucket: bucketName,
      key: fileName,
      file: videoFile,
      draftId: draftID,
      uploadPercentages,
      updateUploadPercentages,
      setUploadContainer,
      setUploadContainer2,
      setIamUploading,
      dummyData: {
        title,
        fileName,
        thumbnail: thumbnailBase64,
        thumbnails: thumbnailsBinary,
        ForNoImage,
        category: selectedCategory.name,
        description,
        videoSize,
        selectedGroups,
        changeSize,
      },
      updateDummy,
      setDraftCategoryState,
      onSuccess: async (draft_id) => {
      console.log('Starting upload for draft ID:', thumbnailBase64);
        const updatedDraftData = {
          title,
          category: selectedCategory.value,
          fileName: videoFile?.name,
          thumbnail: thumbnailBase64,
          thumbnails: thumbnailsBinary,
          selectedThumbnailIndex: isCustomThumbnailSelected ? -1 : selectedThumbnail,
          description,
          videoSize,
          selectedGroups,
          visibility,
          selectedSubCategory,
          selectedPlaylist,
          videoHeight,
          videoWidth,
          orientation: videoHeight < videoWidth ? 1 : 2,
          uploadStatus: 'completed',
          uploadKey: fileName,
          uploadBucket: bucketName,
          s3Url,
        };

        setDraftCategoryState((prevState) => ({
          ...prevState,
          [draft_id]: updatedDraftData,
        }));

        // Create a temporary draftCategoryState object for the API call
        const tempDraftState = {
          [draft_id]: updatedDraftData,
        };

        try {
          await addVideoToAPI(draft_id, tempDraftState);
        } catch (error) {
          console.error('Failed to add video to API:', error);
        }

        setIsPublishing(false);
      },
      onError: (error, draft_id) => {
        console.error('Upload failed for draft:', draft_id, error);
        setIsPublishing(false);
        // You can add more error handling here
      },
      updateUploadDetails,
    });
    handleClose();
    navigate(Pathname.yourVideos);
  };

  // Unused helper functions - kept for potential future use
  // const getVisibilityIcon = () => {
  //   switch (visibility) {
  //     case 'Private':
  //       return <Lock style={{ fontSize: 18, marginRight: 8 }} />;
  //     case 'Group':
  //       return <Group style={{ fontSize: 18, marginRight: 8 }} />;
  //     default:
  //       return <Public style={{ fontSize: 18, marginRight: 8 }} />;
  //   }
  // };

  // const getVisibilityColor = () => {
  //   switch (visibility) {
  //     case 'Private':
  //       return '#EF4444';
  //     case 'Group':
  //       return '#8B5CF6';
  //     default:
  //       return '#10B981';
  //   }
  // };

  const formatDuration = (seconds) => {
    if (!seconds || seconds === 0) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return '0 MB';
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${Math.round((bytes / 1024 ** i) * 100) / 100} ${sizes[i]}`;
  };

  const handleAdditionalOptionsToggle = () => {
    const newState = !showAdditionalFields;
    setShowAdditionalFields(newState);

    // If expanding, scroll to the additional options section after a brief delay
    if (newState && additionalOptionsRef.current) {
      setTimeout(() => {
        additionalOptionsRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 150); // Small delay to allow the collapse animation to start
    }
  };
  const activeFile = videoFile || pendingVideoFile;
  return (
    <>
      <Dialog
        open={open && !showMultipleModal}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 20,
            maxWidth: 1100,
            maxHeight: '92vh',
            boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          },
        }}
      >
        <DialogContent
          style={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}
        >
          {/* Header */}
          <div
            style={{
              padding: '18px 24px',
              backgroundColor: '#fff',
              borderBottom: '1px solid #e5e7eb',
              borderRadius: '20px 20px 0 0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div
                style={{
                  backgroundColor: '#f3f4f6',
                  borderRadius: '10px',
                  padding: '8px',
                  display: 'flex',
                  marginRight: 12,
                }}
              >
                <VideoLibrary
                  style={{ color: '#5aa5ef', fontSize: 24 }}
                />
              </div>
              <h2
                style={{
                  margin: 0,
                  color: '#1f2937',
                  fontSize: 18,
                  fontWeight: 600,
                  fontFamily: 'Montserrat',
                }}
              >
                {videoFile ? 'Upload Video Details' : 'Select Video to Upload'}
              </h2>
            </div>
            <IconButton
              onClick={handleClose}
              style={{ color: '#6b7280' }}
            >
              <Close />
            </IconButton>
          </div>

          {/* Uploading Notification */}
          {/* {hasActiveUploads && (
            <div
              style={{
                padding: '12px 24px',
                backgroundColor: '#EFF6FF',
                borderBottom: '1px solid #DBEAFE',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                animation: 'slideDown 0.3s ease-out',
              }}
            >
              <CircularProgress size={16} thickness={4} style={{ color: '#5aa5ef' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ color: '#1E40AF', fontSize: 13, fontWeight: 500, fontFamily: 'Montserrat' }}>
                  Uploading your files
                </span>
                <div style={{ display: 'flex', gap: 2 }}>
                  <span
                    style={{
                      color: '#1E40AF',
                      animation: 'dot1 1.4s infinite',
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    .
                  </span>
                  <span
                    style={{
                      color: '#1E40AF',
                      animation: 'dot2 1.4s infinite',
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    .
                  </span>
                  <span
                    style={{
                      color: '#1E40AF',
                      animation: 'dot3 1.4s infinite',
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    .
                  </span>
                </div>
              </div>
              <style>
                {`
                  @keyframes slideDown {
                    from {
                      opacity: 0;
                      transform: translateY(-10px);
                    }
                    to {
                      opacity: 1;
                      transform: translateY(0);
                    }
                  }
                  @keyframes dot1 {
                    0%, 20% { opacity: 0; }
                    40% { opacity: 1; }
                    100% { opacity: 0; }
                  }
                  @keyframes dot2 {
                    0%, 40% { opacity: 0; }
                    60% { opacity: 1; }
                    100% { opacity: 0; }
                  }
                  @keyframes dot3 {
                    0%, 60% { opacity: 0; }
                    80% { opacity: 1; }
                    100% { opacity: 0; }
                  }
                `}
              </style>
            </div>
          )} */}

          {/* Content */}
          <div style={{ overflowY: 'auto', padding: '0 24px' }}>
            {isProcessingPendingFile ? (
              // Beautiful loader while processing pending file
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  height: '100%',
                  minHeight: 450,
                  padding: '40px 20px',
                }}
              >
                <div
                  style={{
                    position: 'relative',
                    marginBottom: 32,
                  }}
                >
                  <CircularProgress
                    size={80}
                    thickness={3}
                    style={{ color: '#5aa5ef' }}
                  />
                  <VideoLibrary
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      fontSize: 32,
                      color: '#5aa5ef',
                    }}
                  />
                </div>
                <h3
                  style={{
                    color: '#1A1A1A',
                    fontSize: 18,
                    fontWeight: 600,
                    margin: '0 0 8px 0',
                    fontFamily: 'Montserrat',
                    textAlign: 'center',
                  }}
                >
                  Processing your video...
                </h3>
                <p
                  style={{
                    color: '#6B7280',
                    fontSize: 14,
                    margin: 0,
                    fontFamily: 'Montserrat',
                    textAlign: 'center',
                    maxWidth: 300,
                  }}
                >
                  Please wait while we prepare your video for upload
                </p>
                <div
                  style={{
                    marginTop: 24,
                    display: 'flex',
                    gap: 8,
                  }}
                >
                  <div
                    className="dot"
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      backgroundColor: '#5aa5ef',
                      animation: 'bounce 1.4s infinite ease-in-out both',
                      animationDelay: '0s',
                    }}
                  />
                  <div
                    className="dot"
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      backgroundColor: '#5aa5ef',
                      animation: 'bounce 1.4s infinite ease-in-out both',
                      animationDelay: '0.16s',
                    }}
                  />
                  <div
                    className="dot"
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      backgroundColor: '#5aa5ef',
                      animation: 'bounce 1.4s infinite ease-in-out both',
                      animationDelay: '0.32s',
                    }}
                  />
                </div>
                <style>
                  {`
                  @keyframes bounce {
                    0%, 80%, 100% {
                      transform: scale(0);
                      opacity: 0.5;
                    }
                    40% {
                      transform: scale(1);
                      opacity: 1;
                    }
                  }
                `}
                </style>
              </div>
            ) : activeFile ? (
              <div style={{ display: 'flex', height: 'calc(100% - 140px)', gap: 0 }}>
                {/* Left Side: Form Controls - 45% */}
                <div
                  style={{
                    flex: '0 0 45%',
                    backgroundColor: '#fff',
                    padding: '28px 24px',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 18,
                    borderRight: '1px solid #e5e7eb',
                  }}
                >
                  {/* Video Title */}
                  <div>
                    <label
                      style={{
                        display: 'block',
                        marginBottom: 8,
                        fontSize: 13,
                        fontWeight: 700,
                        color: '#1f2937',
                        fontFamily: 'Montserrat',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}
                    >
                      Video Title
                    </label>
                    <TextField
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Enter an engaging title..."
                      variant="outlined"
                      fullWidth
                      size="small"
                      InputProps={{
                        style: {
                          backgroundColor: '#fff',
                          borderRadius: 10,
                          fontFamily: 'Montserrat',
                          fontSize: 14,
                        },
                      }}
                    />
                  </div>

                  {/* Category & Visibility Row */}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      gap: 16,
                    }}
                  >
                    {/* Category */}
                    <div>
                      <label
                        style={{
                          display: 'block',
                          marginBottom: 8,
                          fontSize: 13,
                          fontWeight: 700,
                          color: '#1f2937',
                          fontFamily: 'Montserrat',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Category
                      </label>
                      <FormControl fullWidth variant="outlined" size="small">
                        <Select
                          value={selectedCategory.value}
                          onChange={(e) => {
                            if (e.target.value === '__create_new__') {
                              setShowCreateCategoryModal(true);
                              return;
                            }
                            const selectedCat = categories?.find(
                              (cat) => cat?.id === e.target.value
                            );
                            setSelectedCategory({
                              value: e.target.value,
                              name: selectedCat?.title,
                            });
                          }}
                          style={{
                            backgroundColor: '#fff',
                            borderRadius: 10,
                            fontFamily: 'Montserrat',
                            fontSize: 13,
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 300,
                              },
                            },
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left',
                            },
                            getContentAnchorEl: null,
                            autoFocus: false,
                            disableAutoFocusItem: true,
                          }}
                        >
                          <MenuItem value="__create_new__">
                            <div style={{ display: 'flex', alignItems: 'center', color: '#5aa5ef' }}>
                              <Add style={{ fontSize: 16, marginRight: 8, color: '#5aa5ef' }} />
                              <span style={{ fontSize: 13, fontFamily: 'Montserrat', fontWeight: 600 }}>Create New Category</span>
                            </div>
                          </MenuItem>
                          <Divider style={{ margin: '4px 0' }} />
                          {categories?.map((cat) => (
                            <MenuItem key={cat?.id} value={cat?.id}>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Category style={{ fontSize: 16, marginRight: 8, color: '#667eea' }} />
                                <span style={{ fontSize: 13, fontFamily: 'Montserrat' }}>{cat?.title}</span>
                              </div>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    {/* Visibility */}
                    <div>
                      <label
                        style={{
                          display: 'block',
                          marginBottom: 8,
                          fontSize: 13,
                          fontWeight: 700,
                          color: '#1f2937',
                          fontFamily: 'Montserrat',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Visibility
                      </label>
                      <FormControl fullWidth variant="outlined" size="small">
                        <Select
                          value={visibility}
                          onChange={(e) => setVisibility(e.target.value)}
                          style={{
                            backgroundColor: '#fff',
                            borderRadius: 10,
                            fontFamily: 'Montserrat',
                            fontSize: 13,
                          }}
                        >
                          <MenuItem value="2">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Public style={{ fontSize: 16, marginRight: 8, color: '#10B981' }} />
                              <span style={{ fontSize: 13, fontFamily: 'Montserrat' }}>All Viewers</span>
                            </div>
                          </MenuItem>
                          <MenuItem value="1">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Lock style={{ fontSize: 16, marginRight: 8, color: '#EF4444' }} />
                              <span style={{ fontSize: 13, fontFamily: 'Montserrat' }}>Private</span>
                            </div>
                          </MenuItem>
                          <MenuItem value="3">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Group style={{ fontSize: 16, marginRight: 8, color: '#8B5CF6' }} />
                              <span style={{ fontSize: 13, fontFamily: 'Montserrat' }}>Group</span>
                            </div>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  {/* Group Selection (when visibility is Group) */}
                  {visibility === '3' && (
                    <div>
                      <label
                        style={{
                          display: 'block',
                          marginBottom: 8,
                          fontSize: 13,
                          fontWeight: 700,
                          color: '#1f2937',
                          fontFamily: 'Montserrat',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Select Groups
                      </label>
                      <div
                        style={{
                          backgroundColor: '#fff',
                          borderRadius: 10,
                          padding: '8px',
                          maxHeight: '160px',
                          overflowY: 'auto',
                          border:
                            visibility === '3' && (!selectedGroups || selectedGroups.length === 0)
                              ? '2px solid #EF4444'
                              : '2px solid #e5e7eb',
                          boxShadow:
                            visibility === '3' && (!selectedGroups || selectedGroups.length === 0)
                              ? '0 0 0 3px rgba(239, 68, 68, 0.1)'
                              : 'none',
                        }}
                      >
                        {!groupsLoaded ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '60px',
                            }}
                          >
                            <CircularProgress
                              size={16}
                              style={{ color: '#5aa5ef' }}
                            />
                            <span
                              style={{
                                marginLeft: '8px',
                                color: '#6B7280',
                                fontSize: '14px',
                                fontFamily: 'Montserrat',
                              }}
                            >
                              Loading groups...
                            </span>
                          </div>
                        ) : groups.length === 0 ? (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '60px',
                              backgroundColor:
                                visibility === '3' ? '#FEF2F2' : 'transparent',
                              border:
                                visibility === '3' ? '2px solid #EF4444' : 'none',
                              borderRadius: visibility === '3' ? '8px' : '0',
                              boxShadow:
                                visibility === '3'
                                  ? '0 0 0 3px rgba(239, 68, 68, 0.1)'
                                  : 'none',
                            }}
                          >
                            <span
                              style={{
                                color: '#9CA3AF',
                                fontStyle: 'italic',
                                fontSize: '14px',
                                fontFamily: 'Montserrat',
                              }}
                            >
                              No groups available
                            </span>
                          </div>
                        ) : (
                          groups.map((group) => (
                            <FormControlLabel
                              key={group.id}
                              control={(
                                <Checkbox
                                  checked={selectedGroups.includes(group.id)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedGroups([
                                        ...selectedGroups,
                                        group.id,
                                      ]);
                                    } else {
                                      setSelectedGroups(
                                        selectedGroups.filter(
                                          (id) => id !== group.id
                                        )
                                      );
                                    }
                                  }}
                                  style={{ color: '#8B5CF6' }}
                                />
                              )}
                              label={(
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <Group style={{ fontSize: 15, marginRight: 8, color: '#8B5CF6' }} />
                                  <span
                                    style={{
                                      fontFamily: 'Montserrat',
                                      fontSize: 13,
                                      color: '#1f2937',
                                      fontWeight: 500,
                                    }}
                                  >
                                    {group.title}
                                  </span>
                                </div>
                              )}
                              style={{
                                margin: '0',
                                padding: '6px 8px',
                                width: '100%',
                                borderRadius: '8px',
                                transition: 'background-color 0.2s ease',
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#f3f4f6';
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                              }}
                            />
                          ))
                        )}
                      </div>
                    </div>
                  )}

                  {/* Additional Options Toggle */}
                  <div
                    ref={additionalOptionsRef}
                    onClick={handleAdditionalOptionsToggle}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '14px 16px',
                      backgroundColor: '#fff',
                      borderRadius: 10,
                      cursor: 'pointer',
                      border: '2px solid #e5e7eb',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.borderColor = '#667eea';
                      e.currentTarget.style.backgroundColor = '#f9fafb';
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = '#667eea';
                      e.currentTarget.style.backgroundColor = '#f9fafb';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.borderColor = '#e5e7eb';
                      e.currentTarget.style.backgroundColor = '#fff';
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = '#e5e7eb';
                      e.currentTarget.style.backgroundColor = '#fff';
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div
                        style={{
                          backgroundColor: '#f3f4f6',
                          borderRadius: '8px',
                          padding: '6px',
                          display: 'flex',
                          marginRight: 10,
                        }}
                      >
                        <Edit style={{ color: '#5aa5ef', fontSize: 16 }} />
                      </div>
                      <span
                        style={{
                          color: '#1f2937',
                          fontSize: 13,
                          fontWeight: 600,
                          fontFamily: 'Montserrat',
                        }}
                      >
                        Additional Options (Optional)
                      </span>
                    </div>
                    {showAdditionalFields ? (
                      <ExpandLess style={{ color: '#5aa5ef', fontSize: 22 }} />
                    ) : (
                      <ExpandMore style={{ color: '#5aa5ef', fontSize: 22 }} />
                    )}
                  </div>

                  {/* Additional Fields */}
                  <Collapse in={showAdditionalFields}>
                    <div
                      style={{
                        marginTop: 16,
                        padding: 18,
                        backgroundColor: '#fff',
                        borderRadius: 10,
                        border: '2px solid #e5e7eb',
                      }}
                    >
                      {/* Description */}
                      <div style={{ marginBottom: 16 }}>
                        <label
                          style={{
                            display: 'block',
                            marginBottom: 8,
                            fontSize: 13,
                            fontWeight: 700,
                            color: '#1f2937',
                            fontFamily: 'Montserrat',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                          }}
                        >
                          Description
                        </label>
                        <TextField
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          placeholder="Add a compelling description for your video..."
                          variant="outlined"
                          fullWidth
                          multiline
                          minRows={3}
                          size="small"
                          InputProps={{
                            style: {
                              backgroundColor: '#fafbfc',
                              borderRadius: 10,
                              fontFamily: 'Montserrat',
                              fontSize: 13,
                            },
                          }}
                        />
                      </div>

                      {/* Subcategory and Playlist Grid */}
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 1fr',
                          gap: 14,
                        }}
                      >
                        {/* Subcategory */}
                        <div>
                          <label
                            style={{
                              display: 'block',
                              marginBottom: 8,
                              fontSize: 13,
                              fontWeight: 700,
                              color: '#1f2937',
                              fontFamily: 'Montserrat',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                            }}
                          >
                            Subcategory
                          </label>
                          <FormControl fullWidth variant="outlined" size="small">
                            <Select
                              value={selectedSubCategory}
                              onChange={(e) => setSelectedSubCategory(e.target.value)}
                              style={{
                                backgroundColor: '#fafbfc',
                                borderRadius: 10,
                                fontFamily: 'Montserrat',
                                fontSize: 13,
                              }}
                            >
                              <MenuItem value="">
                                <span style={{ fontSize: 13, fontFamily: 'Montserrat', color: '#9ca3af' }}>None</span>
                              </MenuItem>
                              {subCategories.map((subcat) => (
                                <MenuItem key={subcat.id} value={subcat.id}>
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Category style={{ fontSize: 15, marginRight: 8, color: '#764ba2' }} />
                                    <span style={{ fontSize: 13, fontFamily: 'Montserrat' }}>{subcat.title}</span>
                                  </div>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                        {/* Playlist */}
                        <div>
                          <label
                            style={{
                              display: 'block',
                              marginBottom: 8,
                              fontSize: 13,
                              fontWeight: 700,
                              color: '#1f2937',
                              fontFamily: 'Montserrat',
                              textTransform: 'uppercase',
                              letterSpacing: '0.5px',
                            }}
                          >
                            Playlist
                          </label>
                          <FormControl fullWidth variant="outlined" size="small">
                            <Select
                              value={selectedPlaylist}
                              onChange={(e) => setSelectedPlaylist(e.target.value)}
                              style={{
                                backgroundColor: '#fafbfc',
                                borderRadius: 10,
                                fontFamily: 'Montserrat',
                                fontSize: 13,
                              }}
                            >
                              <MenuItem value="">
                                <span style={{ fontSize: 13, fontFamily: 'Montserrat', color: '#9ca3af' }}>None</span>
                              </MenuItem>
                              {playlists.map((playlist) => (
                                <MenuItem key={playlist.id} value={playlist.id}>
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <PlaylistPlay style={{ fontSize: 15, marginRight: 8, color: '#764ba2' }} />
                                    <span style={{ fontSize: 13, fontFamily: 'Montserrat' }}>{playlist.title}</span>
                                  </div>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </Collapse>

                  {/* Publish Button - Fixed at bottom of right panel */}
                  <div style={{ marginTop: 'auto', paddingTop: 20 }}>
                    <Button
                      onClick={handlePublish}
                      disabled={
                        !title.trim()
                        || !selectedCategory.value
                        || isGeneratingThumbnails
                        || isPublishing
                        || uploadLimitError
                        || (visibility === '3' && (!selectedGroups || selectedGroups.length === 0))
                      }
                      fullWidth
                      variant="contained"
                      style={{
                        backgroundColor:
                          title.trim() && selectedCategory.value && !isGeneratingThumbnails && !isPublishing && !uploadLimitError
                            && !(visibility === '3' && (!selectedGroups || selectedGroups.length === 0))
                            ? '#5aa5ef'
                            : '#d1d5db',
                        color: 'white',
                        borderRadius: 10,
                        padding: '12px',
                        fontSize: 14,
                        fontWeight: 600,
                        fontFamily: 'Montserrat',
                        boxShadow: 'none',
                        textTransform: 'none',
                      }}
                    >
                      {isPublishing ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                          <CircularProgress size={18} style={{ color: 'white' }} />
                          <span>Publishing...</span>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                          <CloudUpload style={{ fontSize: 20 }} />
                          <span>Publish Video</span>
                        </div>
                      )}
                    </Button>
                  </div>
                </div>

                {/* Right Side: Thumbnail Preview - 55% */}
                <div
                  style={{
                    flex: '0 0 55%',
                    backgroundColor: '#f9fafb',
                    padding: '24px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {/* Main Thumbnail Display */}
                  <div
                    style={{
                      width: '100%',
                      maxWidth: '520px',
                      aspectRatio: '16/9',
                      backgroundColor: '#fff',
                      borderRadius: 12,
                      overflow: 'hidden',
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                      border: '1px solid #e5e7eb',
                    }}
                  >
                    {(isCustomThumbnailSelected && customThumbnail) || thumbnails.length > 0 ? (
                      <img
                        src={isCustomThumbnailSelected && customThumbnail ? customThumbnail : thumbnails[selectedThumbnail]}
                        alt="Selected thumbnail"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    ) : null}
                    {isGeneratingThumbnails && (
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          backgroundColor: 'rgba(255,255,255,0.95)',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <CircularProgress
                          size={40}
                          style={{ color: '#5aa5ef', marginBottom: 16 }}
                        />
                        <span
                          style={{
                            fontSize: 14,
                            fontFamily: 'Montserrat',
                            fontWeight: 500,
                            color: '#6b7280',
                          }}
                        >
                          Generating thumbnails...
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Video Info Badges */}
                  {videoFile && (
                    <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                          padding: '8px 16px',
                          backgroundColor: '#fff',
                          borderRadius: 8,
                          border: '1px solid #e5e7eb',
                        }}
                      >
                        <span style={{ fontSize: 16 }}>⏱️</span>
                        <span
                          style={{
                            fontWeight: 600,
                            fontSize: 14,
                            color: '#374151',
                            fontFamily: 'Montserrat',
                          }}
                        >
                          {formatDuration(videoDuration)}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                          padding: '8px 16px',
                          backgroundColor: '#fff',
                          borderRadius: 8,
                          border: '1px solid #e5e7eb',
                        }}
                      >
                        <span style={{ fontSize: 16 }}>📁</span>
                        <span
                          style={{
                            fontWeight: 600,
                            fontSize: 14,
                            color: '#374151',
                            fontFamily: 'Montserrat',
                          }}
                        >
                          {formatFileSize(videoSize)}
                        </span>
                      </div>
                    </div>
                  )}

                  {/* Thumbnail Selection Grid */}
                  {thumbnails.length > 0 && (
                    <div style={{ marginTop: 24, width: '100%', maxWidth: '520px' }}>
                      <h3
                        style={{
                          color: '#6b7280',
                          fontSize: 12,
                          fontWeight: 600,
                          fontFamily: 'Montserrat',
                          margin: '0 0 12px 0',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        Choose Thumbnail
                      </h3>
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(4, 1fr)',
                          gap: 8,
                        }}
                      >
                        {/* Custom Thumbnail Upload Option */}
                        <div
                          onClick={() => {
                            if (customThumbnail) {
                              setIsCustomThumbnailSelected(true);
                              setSelectedThumbnail(null);
                            } else {
                              customThumbnailInputRef.current?.click();
                            }
                          }}
                          style={{
                            position: 'relative',
                            cursor: 'pointer',
                            borderRadius: 6,
                            overflow: 'hidden',
                            border: isCustomThumbnailSelected
                              ? '2px solid #5aa5ef'
                              : '2px dashed #d1d5db',
                            aspectRatio: '16/9',
                            transition: 'all 0.2s ease',
                            boxShadow: isCustomThumbnailSelected
                              ? '0 0 0 3px rgba(90, 165, 239, 0.1)'
                              : 'none',
                            backgroundColor: customThumbnail ? 'transparent' : '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {customThumbnail ? (
                            <>
                              <img
                                src={customThumbnail}
                                alt="Custom thumbnail"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                }}
                              />
                              {isCustomThumbnailSelected && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 4,
                                    right: 4,
                                    width: 20,
                                    height: 20,
                                    backgroundColor: '#5aa5ef',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <CheckCircle
                                    style={{ color: 'white', fontSize: 14 }}
                                  />
                                </div>
                              )}
                            </>
                          ) : (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 4,
                                padding: 6,
                              }}
                            >
                              <CloudUpload
                                style={{
                                  color: '#9ca3af',
                                  fontSize: 18,
                                }}
                              />
                              <span
                                style={{
                                  color: '#6b7280',
                                  fontSize: 9,
                                  fontFamily: 'Montserrat',
                                  fontWeight: 600,
                                  textAlign: 'center',
                                }}
                              >
                                Custom
                              </span>
                            </div>
                          )}
                        </div>
                        <input
                          ref={customThumbnailInputRef}
                          type="file"
                          accept="image/jpeg,image/jpg,image/png,image/webp"
                          onChange={handleCustomThumbnailUpload}
                          style={{ display: 'none' }}
                        />
                        {/* Generated Thumbnails */}
                        {thumbnails.map((thumb, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setSelectedThumbnail(index);
                              setIsCustomThumbnailSelected(false);
                            }}
                            style={{
                              position: 'relative',
                              cursor: 'pointer',
                              borderRadius: 6,
                              overflow: 'hidden',
                              border:
                                selectedThumbnail === index && !isCustomThumbnailSelected
                                  ? '2px solid #5aa5ef'
                                  : '1px solid #e5e7eb',
                              aspectRatio: '16/9',
                              transition: 'all 0.2s ease',
                              boxShadow:
                                selectedThumbnail === index && !isCustomThumbnailSelected
                                  ? '0 0 0 3px rgba(90, 165, 239, 0.1)'
                                  : 'none',
                            }}
                          >
                            <img
                              src={thumb}
                              alt={`Thumbnail ${index + 1}`}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }}
                            />
                            {selectedThumbnail === index && !isCustomThumbnailSelected && (
                              <div
                                style={{
                                  position: 'absolute',
                                  top: 4,
                                  right: 4,
                                  width: 20,
                                  height: 20,
                                  backgroundColor: '#5aa5ef',
                                  borderRadius: '50%',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <CheckCircle
                                  style={{ color: 'white', fontSize: 14 }}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  minHeight: 400,
                }}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".mp4,.mov,.mpg,.m4v,.m2ts,.hevc,.h264"
                  multiple
                  onChange={handleFileSelect}
                  style={{ display: 'none' }}
                />
                <div
                  onClick={() => fileInputRef.current?.click()}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  style={{
                    width: '100%',
                    maxWidth: 500,
                    padding: '60px 40px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    border: '2px dashed #D1D5DB',
                    backgroundColor: '#FAFBFC',
                    borderRadius: 16,
                    transition: 'all 0.3s ease',
                    ':hover': {
                      borderColor: '#5aa5ef',
                      backgroundColor: '#F0F7FF',
                    },
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = '#5aa5ef';
                    e.target.style.backgroundColor = '#F0F7FF';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = '#D1D5DB';
                    e.target.style.backgroundColor = '#FAFBFC';
                  }}
                >
                  <CloudUpload
                    style={{
                      fontSize: 64,
                      color: '#5aa5ef',
                      marginBottom: 16,
                    }}
                  />
                  <h3
                    style={{
                      color: '#1A1A1A',
                      margin: '0 0 8px 0',
                      fontSize: 18,
                      fontWeight: 600,
                      fontFamily: 'Montserrat',
                    }}
                  >
                    Choose Video File
                  </h3>
                  <p
                    style={{
                      color: '#6B7280',
                      margin: '0 0 16px 0',
                      fontSize: 14,
                      fontFamily: 'Montserrat',
                    }}
                  >
                    Click to browse or drag and drop your video here
                  </p>
                  <p
                    style={{
                      color: '#9CA3AF',
                      margin: 0,
                      fontSize: 12,
                      fontFamily: 'Montserrat',
                    }}
                  >
                    Supported formats: MP4, MOV, MPG, M4V, M2TS, HEVC, H264
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Upload Limit Error Display */}
          {uploadLimitError && videoFile && (
            <div
              style={{
                position: 'absolute',
                bottom: 20,
                left: '55%',
                right: 20,
                margin: '0 24px',
                padding: 14,
                backgroundColor: '#FEF2F2',
                border: '2px solid #EF4444',
                borderRadius: 12,
                color: '#DC2626',
                boxShadow: '0 4px 20px rgba(239, 68, 68, 0.2)',
                zIndex: 10,
              }}
            >
              <h4
                style={{ margin: '0 0 6px 0', fontSize: 13, fontWeight: 700, fontFamily: 'Montserrat' }}
              >
                ⚠️ Upload Limit Exceeded
              </h4>
              <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, fontFamily: 'Montserrat' }}>
                {uploadLimitError.message}
              </p>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Multiple Video Upload Modal */}
      {showMultipleModal && (
        <MultipleVideoUploadModal
          open={showMultipleModal}
          onClose={() => {
            setShowMultipleModal(false);
            setSelectedFilesMulti([]);
            setUploadLimitError(null);
            // Close the main modal too
            handleClose();
          }}
          initialFiles={selectedFilesMulti}
          uploadLimitError={uploadLimitError}
          userData={userDataProp}
        />
      )}

      {/* Create Category Modal */}
      {showCreateCategoryModal && (
        <CreateCategoryPage
          initialOpen={showCreateCategoryModal}
          onModalClose={() => setShowCreateCategoryModal(false)}
          onCategoryCreated={handleCategoryCreated}
        />
      )}
    </>
  );
};

export default VideoUploadModal;
